import { useMediaQuery } from '@mui/material';

/**
 * Schwelle fuer die kompakte Dichte (Kompakt-Modus, Decision #247).
 *
 * Unter 1600 px Fensterbreite liegen alle verbreiteten Laptop-Aufloesungen:
 * 1280 (Full HD bei 150 % Windows-Skalierung), 1366 (HD), 1440 (MacBook
 * Air), 1536 (Full HD bei 125 %). Ab 1600 beginnen die Monitore (1680,
 * 1920) — dort bleibt alles wie bisher. Gemessen wird die Fensterbreite,
 * nicht der Bildschirm: wer auf einem grossen Monitor ein halbes Fenster
 * nutzt, bekommt ebenfalls die kompakte Fassung.
 */
export const KLEINER_BILDSCHIRM_BREITE = 1600;

export const KLEINER_BILDSCHIRM_QUERY = `(max-width: ${KLEINER_BILDSCHIRM_BREITE - 0.02}px)`;

/**
 * true unter der Schwelle. Ohne `matchMedia` (jsdom in Jest) immer false —
 * Tests sehen die normale Fassung.
 */
export const useKleinerBildschirm = (): boolean =>
  useMediaQuery(KLEINER_BILDSCHIRM_QUERY, { noSsr: true });
